import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {AuthShortcutsComponent} from './auth-shortcuts.component'
import {AuthModule} from '../../../../auth/auth.module'
import {RouterModule} from '@angular/router'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {TranslocoModule} from '@ngneat/transloco'
import {LoginShortcutsComponent} from './login-shortcuts/login-shortcuts.component'
import {PipesModule} from '../../../../../shared/pipes/pipes.module'
import {TabsModule} from '../../../../../craft/tabs/tabs.modules'
import {TooltipComponent} from '../../../../../craft/tooltip/tooltip.component'
import {ShortcutComponent} from './shortcut.component'
import {NotificationBulletComponent} from '../../../../../craft/notification-bullet/notification-bullet.component'
import {PrioritizedUserRolePipe} from '../../../../../shared/pipes/prioritized-user-role.pipe'
import {PerspectivePipe} from '../perspective.pipe'

@NgModule({
  declarations: [AuthShortcutsComponent, LoginShortcutsComponent, ShortcutComponent],
  imports: [
    CommonModule,
    AuthModule,
    RouterModule,
    FontAwesomeModule,
    TranslocoModule,
    PipesModule,
    TabsModule,
    TooltipComponent,
    NotificationBulletComponent,
    PrioritizedUserRolePipe,
    PerspectivePipe,
  ],
  bootstrap: [AuthShortcutsComponent],
})
export class AuthShortcutsModule {}
